import React, { Component } from "react";
import PropTypes from "prop-types";
import { ConfirmDelete, Authorized } from "MODULES/shared/components";
import {
  CAN_ADD_UPDATE_APPLICATIONS,
  ROLES,
  WAREHOUSE,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";
import classNames from "classnames";
import { without } from "lodash";

export default class Tag extends Component {
  static propTypes = {
    addOn: PropTypes.element,
    className: PropTypes.string,
    color: PropTypes.string,
    destroy: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    onLabelClick: PropTypes.func
  };

  state = {
    open: false
  };

  onLabelClick = label =>
    this.props.onLabelClick && this.props.onLabelClick(label);

  open = () => this.setState({ open: true });

  close = () => this.setState({ open: false });

  render() {
    const {
      addOn,
      className,
      color,
      label,
      destroy,
      onLabelClick
    } = this.props;

    let labelColor;

    if (onLabelClick) {
      labelColor = color || "#FF9800";
    } else {
      labelColor = "#FFFFFF";
    }

    const labelStyle = {
      cursor: onLabelClick ? "pointer" : "default",
      color: labelColor
    };

    const labelClasses = classNames("btn btn-xs btn-default", className);

    return (
      <div className="btn-group" style={{ marginBottom: 4, marginRight: 2 }}>
        <button
          style={labelStyle}
          type="button"
          className={labelClasses}
          onClick={this.onLabelClick}
        >
          {addOn}
          {label}
        </button>
        <Authorized
          permissions={[CAN_ADD_UPDATE_APPLICATIONS]}
          roles={without(ROLES, WAREHOUSE)}
          subroles={[WAREHOUSE_LOGISTICS_DIRECTOR]}
        >
          <button
            type="button"
            className="btn btn-xs btn-default"
            onClick={this.open}
          >
            <span>
              <i className="fa fa-close" />
            </span>
          </button>
          <ConfirmDelete
            onConfirm={destroy}
            close={this.close}
            open={this.state.open}
          >
            <strong>Heads up!</strong> Are you sure you want to delete this?
          </ConfirmDelete>
        </Authorized>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Tag/Tag.jsx